import React from 'react';
import { pageTitle } from '../PageTitle';
import BreadCrumb from '../BreadCrumb';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import { Link } from 'react-router-dom';

const ContractVehicles = () => {
    pageTitle('Contract Vehicles');

    const gsaSins = [
        {
            code: '541330ENG',
            name: 'Engineering Services',
            description:
                'Apply engineering principles to the design, development, and utilization of systems and processes—including concept development, requirements analysis, feasibility studies, plans and designs, and technical evaluation support.',
        },
        {
            code: '541715',
            name: 'Engineering R&D and Strategic Planning',
            description:
                'Research and experimental development in the physical, engineering, and life sciences, plus related strategic planning—mission analysis, trade-off studies, program evaluation, technology insertion, and consulting.',
        },
        {
            code: '518210C',
            name: 'Cloud & Cloud-Related IT Services',
            description:
                'Cloud computing (IaaS, PaaS, SaaS) and related IT professional services supporting cloud adoption, migration, governance, DevOps, cloud-native development, and cloud-based AI/ML capabilities.',
        },
        {
            code: '54151S',
            name: 'IT Services',
            description:
                'Information Technology Professional Services—including IT systems development, implementation, support, and related consulting.',
        },
    ];

    const shieldWorkAreas = [
        'Science & Technology',
        'Research & Development',
        'Prototyping & Demonstrations',
        'Disruptive Technologies',
        'Architecture Development',
        'Modeling, Simulation & Analysis',
        'Systems Engineering',
        'Weapon Design & Development',
        'Integration & Fielding',
        'Test & Evaluation',
        'Operations & Sustainment',
        'Modernization',
        'Hardware & Software Mods',
        'Data Mining & Analysis',
        'Mission-Related IT',
        'Cybersecurity',
    ];

    return (
        <>
            <HeaderOne />
            <BreadCrumb title={"Contract Vehicles"} />

            <section className="cv-page p_relative">
                <div className="cv-page__glow cv-page__glow--one" aria-hidden="true" />
                <div className="cv-page__glow cv-page__glow--two" aria-hidden="true" />

                <div className="auto-container">
                    <div className="cv-intro wow fadeInUp" data-wow-delay="0ms">
                        <div className="title__data">
                            <div className="sub__title">
                                <h4>Federal Contracting</h4>
                            </div>
                            <div className="title">
                                <h2>Pathways to Partner with ERI</h2>
                            </div>
                        </div>
                        <p className="cv-intro__lead">
                            Epitome Research &amp; Innovations Inc. is a federal prime contractor.
                            Government customers can engage ERI through established vehicles for
                            engineering, research and development, and cloud-related IT professional services.
                        </p>
                    </div>

                    <div className="cv-vehicles">
                        <article className="cv-vehicle wow fadeInUp" data-wow-delay="100ms">
                            <div className="cv-vehicle__top">
                                <span className="cv-vehicle__label">DoD Enterprise Vehicle</span>
                                <h3 className="cv-vehicle__title">MDA SHIELD IDIQ</h3>
                                <p className="cv-vehicle__fullname">
                                    <span>Contract Number: </span>
                                    <strong>HQ085926DF211</strong>
                                </p>
                            </div>
                            <div className="cv-vehicle__body">
                                <p>
                                    ERI is an awardee under the Missile Defense Agency&apos;s
                                    <strong> Scalable Homeland Innovative Enterprise Layered Defense (SHIELD)</strong> Multiple Award IDIQ.
                                    SHIELD enables MDA and other DoD entities to rapidly compete and issue task orders under one flexible enterprise framework.
                                </p>
                                <p>
                                    The vehicle emphasizes speed and agility—supporting AI/ML where appropriate, digital engineering,
                                    open systems architectures, model-based systems engineering, and agile processes across acquisition, development, and sustainment.
                                </p>
                                <dl className="cv-meta">
                                    <div>
                                        <dt>Primary NAICS</dt>
                                        <dd>541715 — R&amp;D in Physical, Engineering &amp; Life Sciences</dd>
                                    </div>
                                    <div>
                                        <dt>Period of Performance</dt>
                                        <dd>Up to 10 years (through Dec 2035 if options exercised)</dd>
                                    </div>
                                    <div>
                                        <dt>Funding</dt>
                                        <dd>Obligated at the task-order level</dd>
                                    </div>
                                </dl>
                            </div>
                        </article>

                        <article className="cv-vehicle cv-vehicle--accent wow fadeInUp" data-wow-delay="200ms">
                            <div className="cv-vehicle__top">
                                <span className="cv-vehicle__label">GSA Schedule</span>
                                <h3 className="cv-vehicle__title">GSA Multiple Award Schedule</h3>
                                <p className="cv-vehicle__number">
                                    <span>Contract Number:</span>
                                    <strong>47QRAA26D005Y</strong>
                                </p>
                            </div>
                            <div className="cv-vehicle__body">
                                <p>
                                    ERI holds a GSA Multiple Award Schedule (MAS) contract, giving federal, state, and local government
                                    customers a pre-negotiated pathway to order commercial services with established terms and pricing.
                                </p>
                                <dl className="cv-meta">
                                    <div>
                                        <dt>Special Item Numbers (SINs)</dt>
                                        <dd>
                                            SIN 541330ENG — Engineering Services<br />
                                            SIN 541715 — Engineering R&amp;D and Strategic Planning<br />
                                            SIN 518210C — Cloud Computing and Cloud Related IT Professional Services<br />
                                            SIN 54151S — IT Services
                                        </dd>
                                    </div>
                                    <div>
                                        <dt>Ordering Period Ends</dt>
                                        <dd>May 6, 2031</dd>
                                    </div>
                                    <div>
                                        <dt>Ultimate End Date</dt>
                                        <dd>May 6, 2046 (if all options exercised)</dd>
                                    </div>
                                    <div>
                                        <dt>Catalog</dt>
                                        <dd>
                                            <a
                                                href="https://www.gsaelibrary.gsa.gov/ElibMain/contractorInfo.do?contractNumber=47QRAA26D005Y&contractorName=EPITOME+RESEARCH+AND+INNOVATIONS+INC.&executeQuery=YES"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                View on GSA eLibrary
                                            </a>
                                        </dd>
                                    </div>
                                </dl>
                            </div>
                        </article>
                    </div>

                    <div className="cv-section wow fadeInUp" data-wow-delay="100ms">
                        <div className="cv-section__header">
                            <h3>SHIELD Work Areas</h3>
                            <p>Representative scope available under the MDA SHIELD IDIQ.</p>
                        </div>
                        <ul className="cv-tags">
                            {shieldWorkAreas.map((area) => (
                                <li key={area}>{area}</li>
                            ))}
                        </ul>
                    </div>

                    <div className="cv-section wow fadeInUp" data-wow-delay="150ms">
                        <div className="cv-section__header">
                            <h3>GSA Special Item Numbers (SINs)</h3>
                            <p>Authorized categories on ERI&apos;s Multiple Award Schedule.</p>
                        </div>
                        <div className="cv-sins">
                            {gsaSins.map((sin) => (
                                <article className="cv-sin" key={sin.code}>
                                    <div className="cv-sin__code">SIN {sin.code}</div>
                                    <h4>{sin.name}</h4>
                                    <p>{sin.description}</p>
                                </article>
                            ))}
                        </div>
                    </div>

                    <div className="cv-cta wow fadeInUp" data-wow-delay="100ms">
                        <div className="cv-cta__content">
                            <h3>Ready to engage?</h3>
                            <p>
                                Discuss requirements, capabilities, and ordering pathways for engineering,
                                R&amp;D, simulation, AI/ML, or cloud-related IT professional services.
                            </p>
                        </div>
                        <Link to="/contact" className="theme-btn theme-btn-one">
                            Contact Us <i className="icon-02"></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterOne />
        </>
    );
};

export default ContractVehicles;
